import React, { memo, useState, useEffect } from 'react';
import { useTranslate } from 'react-polyglot';
import { TextField } from '@rmwc/textfield';
import '@material/textfield/dist/mdc.textfield.css';
import '@material/floating-label/dist/mdc.floating-label.css';
import '@material/notched-outline/dist/mdc.notched-outline.css';
import '@material/line-ripple/dist/mdc.line-ripple.css';
import '@material/ripple/dist/mdc.ripple.css';
import '@rmwc/icon/icon.css';
import ActionButtons from '../actionsDialog/ActionButtons';



const DeleteAccount = memo(function DeleteAccount(props) {
    const t = useTranslate();
    const [value, setValue] = useState('');
    const [enabled, setEnabled] = useState(false)

    useEffect(() => {
        if (value === props.data.email) {
            setEnabled(true)
        } else {
            setEnabled(false);
        }
    }, [value])

    return (
        <div className='coa-dialog-form coa-dialog-with-action-buttons'>
            <p className='coa-dialog-msg'>{t('pages.profile.deleteAccount.msg')}</p>
            <p className='coa-dialog-msg-body'>{t('pages.profile.deleteAccount.msgBody')}</p>
            <div className={'profile-item-field'}>
                <TextField outlined label={t('pages.profile.deleteAccount.inputLabel')} name="mail" className={'fullwidth'} value={value} onChange={(e) => { setValue(e.target.value); }}/>
            </div>
            <ActionButtons
                cancelText={t('actions.cancel')}
                acceptText={t('actions.delete')}
                acceptDisabled={!enabled}
                acceptVariant="danger"
                onClickCancel={(e) => {
                    e.preventDefault();
                    props.setOpen(false);
                }}
                onClickAccept={(e) => {
                    if (enabled) {
                        props.data.deleteUserAccount({name: value});
                    }
                }}
            ></ActionButtons>
        </div>
    )
})


export default DeleteAccount
